import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {forkJoin} from 'rxjs';
import {AuthService} from "./auth.service";

@Injectable({
  providedIn: 'root'
})
export class ExchangeService {

  private countryCodesResult: [];
  private ratesResult: [];

  constructor(
    private authService: AuthService,
    private http: HttpClient) {
    this.load();

    this.authService.onLogin()
      .subscribe(() => {
        this.load();
      });
  }

  load() {
    if(localStorage.getItem('verity_token')) {
      const countryCodes = this.http.post('getcurrencyrates/', {});
      const rates = this.http.post('getcurrencyrates/', {option: 'iso'});

      forkJoin([countryCodes, rates])
        .subscribe((result: Array<any>) => {
          this.ratesResult = result[0];
          this.countryCodesResult = result[1];
        }, error => this.load());
    }
  }

  getRatioForCountry(country: string, targetCurrenct: string) {
    const currencyCode = this.findCurrencyCode(country);

    switch (targetCurrenct) {
      case 'EUR':
        return this.findEuroRate(currencyCode);
      case 'USD':
        return this.findUSDRate(currencyCode);
      case 'LCU':
        return 1;
    }
  }

  public findCurrencyCode(country: string) {
    const countryCode = this.countryCodesResult.find(r => r['Country_name'] === country);
    if (countryCode) {
      return countryCode['Currency_code'];
    }

    return undefined;
  }

  private findEuroRate(currencyCode: string) {
    const rateEntry = this.ratesResult.find(r => r['Currency_from_cd'] === currencyCode);

    if (rateEntry) {
      return rateEntry['Conv_to_EUR'];
    }

    return undefined;
  }

  private findUSDRate(currencyCode: string) {
    const rateEntry = this.ratesResult.find(r => r['Currency_from_cd'] === currencyCode);

    if (rateEntry) {
      return rateEntry['Conv_to_USD'];
    }

    return undefined;
  }
}

export function exchangeProviderFactory(exchangeService: ExchangeService) {
  return () => exchangeService.load();
}
